import { render, staticRenderFns } from "./currencymod.vue?vue&type=template&id=89c3afdc&"
import script from "./currencymod.vue?vue&type=script&lang=js&"
export * from "./currencymod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89c3afdc')) {
      api.createRecord('89c3afdc', component.options)
    } else {
      api.reload('89c3afdc', component.options)
    }
    module.hot.accept("./currencymod.vue?vue&type=template&id=89c3afdc&", function () {
      api.rerender('89c3afdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2o6g5fINOb4IB/JS/comp/currencymod.vue"
export default component.exports